import React, {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import UsuarioFormPartial from '../components/partials/UsuarioFormPartial';

const UsuarioForm = () => {
  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)

  let { id } = useParams();

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true /* && authInformation.rol === 'Admin' */ ){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  return (
    <div>
      {renderHTML && (
        <UsuarioFormPartial id={id} />
      )}
    </div>
  );
};

export default UsuarioForm;